<template>
    <div class="wrapper">
        <WarningIcon color="#fff" width="64" height="64" />

        <h1>{{ $t('title') }}</h1>

        <p>{{ $t('description') }}</p>

        <p class="bottom-text">
            {{ $t('loginQuestion') }}
            <router-link :to="{ name: 'login' }">
                {{ $t('loginLink') }}
            </router-link>
        </p>
    </div>
</template>

<script>
import WarningIcon from './icons/WarningIcon'

export default {
    name: 'InvalidTokenWarning',
    components: {
        WarningIcon,
    },
}
</script>

<i18n>
{
    "en": {
        "description": "Please check the link or contact the person who shared it with you.",
        "loginLink": "Click here to log in",
        "loginQuestion": "Do you have an account?",
        "title": "Invalid sharing link"
    },
    "de": {
        "description": "Bitte überprüfen Sie den Link oder kontaktieren Sie die Person, die ihn mit Ihnen geteilt hat.",
        "loginLink": "Klicke hier, um dich anzumelden",
        "loginQuestion": "Hast du ein Konto?",
        "title": "Ungültiger Freigabelink"
    },
    "fr": {
        "description": "Veuillez vérifier le lien ou contacter la personne qui vous l’a partagé.",
        "loginLink": "Cliquez ici pour vous connecter",
        "loginQuestion": "Vous avez un compte ?",
        "title": "Lien de partage invalide"
    },
    "it": {
        "description": "Controlla il link o contatta la persona che te lo ha condiviso.",
        "loginLink": "Clicca qui per accedere",
        "loginQuestion": "Hai un account?",
        "title": "Link di condivisione non valido"
    }
}
</i18n>

<style lang="scss" scoped>
.wrapper {
    position: fixed;
    top: 64px;
    width: 100%;
    height: calc(100% - 64px);
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.85);
    color: #fff;
    user-select: none;
    z-index: 110;

    @include respond-to('for-mobile-down') {
        top: 55px;
        height: calc(100% - 55px);
    }

    & > * {
        max-width: 320px;
        margin-bottom: 24px;
        text-align: center;
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    }

    .bottom-text {
        position: fixed;
        bottom: 0;

        a {
            text-decoration: underline;

            &:hover {
                text-decoration: none;
            }
        }
    }
}
</style>
